import React from 'react';
import { FooterContainer } from './Footer.styled';

function Footer() {
    return (
        <FooterContainer>
            <p>© 2025 Duo a Color by Saint Torus. Todos los derechos reservados.</p>
        </FooterContainer>
    );
}

export default Footer;